import {ISupportFAQ} from '@wearesection/bandai-react-components/organisms/SupportFAQ';
import {IContactInfoProps} from '@wearesection/bandai-react-components/organisms/SupportInfo';
import {
  IconOrders,
  IconShipping,
  IconRefunds,
  IconDiscountCodes,
} from '@wearesection/bandai-react-components/atoms/Icon';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
// import {getOptions} from './body-rich-text-renderer-options';
import {Box} from '@mui/material';
import {Question, QuestionListing} from '~/graphql/types';
import {GetRouter} from '~/utils';
import dynamic from 'next/dynamic';
import {getOptions} from '../body-article/body-rich-text-renderer-options';
import {useEffect, useState} from 'react';
const SupportFAQ = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/SupportFAQ'),
  {ssr: false}
);
const SupportInfo = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/SupportInfo'),
  {ssr: false}
);
let supportInfoProps: JSX.IntrinsicAttributes & IContactInfoProps;

const adapter = (data: any) => {
  const {locale} = GetRouter();

  const defaultAccordion: QuestionListing = data?.questionListingCollection?.items[4] || [];
  supportInfoProps = {
    title: data.supportInfoTitle ?? 'Have other questions in mind?',
    button: {
      label: data.supportButtonLabel ?? 'Contact us',
      externalLink: `/${locale}/contact-us`,
      target: '_parent',
      variant: 'primaryDark',
    },
    mainImageUrl:
      'https://images.ctfassets.net/hnoi7ctzfs57/5dyuLVwyr6XySdTFahsmFX/6a25573efcbcced7d0bfdae6760dc676/Support.png?h=250',
    mainImageUrlMobile:
      'https://images.ctfassets.net/hnoi7ctzfs57/5dyuLVwyr6XySdTFahsmFX/d5b2e2e421cca43fdea1990cf50bb959/Support.png?h=250',
  };

  return {
    title: data?.title ?? 'Support',
    secondaryTitle: data?.secondaryTitle ?? 'Our terms & policies',
    listAccordion:
      data?.questionListingCollection?.items?.map((item: QuestionListing) => {
        return {
          key: item?.key ?? '',
          accordionItems: item?.questionsCollection?.items.map((accordion: Question | any) => {
            return {
              label: accordion?.label ?? '',
              content: documentToReactComponents(
                accordion?.content?.json,
                getOptions(accordion?.content)
              ),
            };
          }),
        };
      }) ?? [],
    listAccordionDefault: [
      {
        key: data?.popularQuestionsLabel,
        accordionItems:
          defaultAccordion?.questionsCollection?.items?.map((accordion: Question | any) => {
            return {
              label: accordion?.label,
              content: documentToReactComponents(
                accordion?.content?.json,
                getOptions(accordion?.content)
              ),
            };
          }) ?? [],
      },
    ],
    listTabIcons: [
      {
        id: 1,
        label: data?.ordersLabel ?? 'Orders',
        icon: <IconOrders />,
      },
      {
        id: 2,
        label: data?.shippingAndDeliveryLabel ?? 'Shipping & delivery',
        icon: <IconShipping />,
      },
      {
        id: 3,
        label: data?.returnAndRefundsLabel ?? 'Returns & refunds',
        icon: <IconRefunds />,
      },
      {
        id: 4,
        label: data?.disscountCodeLabel ?? 'Discount codes',
        icon: <IconDiscountCodes />,
      },
    ],
    listLink: data.dataPagePolicy.map((item: any) => ({
      href: `/${locale}${item.href}`,
      label: item.label,
    })),
  };
};

const SupportFaq: React.FC<ISupportFAQ> = props => {
  const ComponentProps = adapter(props);
  const {query} = GetRouter();

  const [tabSelect, setTabSelect] = useState<any>(-1);

  useEffect(() => {
    if (query?.tab === 'return_refund') {
      setTabSelect(2);
    }
  }, [query]);

  return (
    <Box
      sx={{
        padding: {
          xs: '72px 0 32px',
          md: '80px 0',
        },
      }}
    >
      <SupportFAQ {...ComponentProps} tabSelect={tabSelect} />
      <Box
        sx={{
          paddingTop: {
            xs: '60px',
            md: '77px',
          },
        }}
      >
        <SupportInfo {...supportInfoProps} />
      </Box>
    </Box>
  );
};

export default SupportFaq;
